/* CYGNUSS 21/10/2026: script do modal de compra rapida (CygnussQuickAdd + parcelamento),
   antes inline no fim de toda pagina em snippets/cygnuss-quick-add-modal.liquid. Mesmo codigo; agora fica em cache. */
(function() {
  'use strict';

  /* CYGNUSS 21/10/2026: parcelamento global via settings (cy_installment_count,
     cy_installment_show_no_interest, cy_installment_enabled, cy_installment_factor).
     Os valores vem do JSON #cyg-parcelas-config impresso por snippets/cygnuss-quick-add-modal.liquid,
     com as mesmas regras de antes (o padrao abaixo e o mesmo do snippet). */
  var cygParcelasCfg = {};
  try {
    var cygParcelasEl = document.getElementById('cyg-parcelas-config');
    if (cygParcelasEl) cygParcelasCfg = JSON.parse(cygParcelasEl.textContent) || {};
  } catch (e) { cygParcelasCfg = {}; }
  var CYG_INSTALLMENT = {
    enabled: cygParcelasCfg.enabled !== false,
    count: cygParcelasCfg.count != null ? cygParcelasCfg.count : 8,
    showNoInterest: cygParcelasCfg.showNoInterest === true,
    factor: parseFloat(cygParcelasCfg.factor != null ? cygParcelasCfg.factor : '1.0000') || 1.0
  };
  // Se "sem juros" estiver marcado, ignora o factor (sempre 1.0)
  if (CYG_INSTALLMENT.showNoInterest) CYG_INSTALLMENT.factor = 1.0;

  var CygnussQuickAdd = {
    currentProduct: null,
    selectedVariant: null,
    
    init: function() {
      console.log('🚀 Cygnuss Quick Add v8 inicializado');
      this.bindEvents();
      this.initQuickAddButtons();
    },
    
    bindEvents: function() {
      var self = this;
      var overlay = document.getElementById('cyModalOverlay');
      var closeBtn = document.getElementById('cyModalClose');
      
      if (overlay) overlay.addEventListener('click', function() { self.closeModal(); });
      if (closeBtn) closeBtn.addEventListener('click', function() { self.closeModal(); });
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape') self.closeModal(); });
    },
    
    initQuickAddButtons: function() {
      var self = this;

      // CAUSA-RAIZ DO BUG "ATC do card as vezes nao adiciona":
      // O setup anterior fazia addEventListener POR-BOTAO em capture phase
      // e usava um MutationObserver com setTimeout(setupButtons, 100) p/
      // pegar botoes recem-injetados. Durante a janela de 100ms, o botao
      // existe no DOM mas SEM listener — clique nesse intervalo borbulhava
      // p/ o <a href> do produto envolvendo o card e navegava p/ a
      // PDP em vez de abrir o modal. Igual em re-renders de section
      // (collection, recommendations) que substituem nodes.
      //
      // FIX: delegacao em document, capture phase, registrada UMA UNICA VEZ.
      // Vale p/ qualquer .cy-quick-add-btn que existe agora ou que entrar
      // no DOM no futuro, sem depender de polling/observer/setTimeout.
      if (window.__cyQuickAddBound) return;
      window.__cyQuickAddBound = true;

      // Click delegado em capture: roda ANTES de qualquer handler
      // burbulhante (incluindo navegacao do <a> ancestral).
      document.addEventListener('click', function(e) {
        var btn = e.target && e.target.closest && e.target.closest('.cy-quick-add-btn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var productHandle = btn.getAttribute('data-product-handle');
        if (productHandle) self.loadProduct(productHandle);
        return false;
      }, true);

      // Pointer events em capture p/ impedir o <a> envolvendo o card de
      // disparar :hover/focus/touch que poderiam acionar comportamentos
      // de navegacao em iOS Safari (onde touchstart->click pode ser
      // sintetizado mesmo apos preventDefault no click subsequente).
      ['mousedown', 'mouseup'].forEach(function(evt) {
        document.addEventListener(evt, function(e) {
          var btn = e.target && e.target.closest && e.target.closest('.cy-quick-add-btn');
          if (!btn) return;
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true);
      });
      ['touchstart', 'touchend'].forEach(function(evt) {
        document.addEventListener(evt, function(e) {
          var btn = e.target && e.target.closest && e.target.closest('.cy-quick-add-btn');
          if (!btn) return;
          e.stopPropagation();
        }, { passive: true, capture: true });
      });
    },
    
    loadProduct: function(handle) {
      var self = this;
      
      fetch('/products/' + handle + '.js')
        .then(function(res) { return res.json(); })
        .then(function(product) {
          /* CYGNUSS 31/10/2026: com Vender so a unidade (cyg_so_unidade) as cores de kit saem do modal, igual a pagina do produto.
             Mesma regra de kit de snippets/cyg-e-kit (copia em assets/cart-upsell.js). Produto so com kit fica como esta. */
          if (cygParcelasCfg.soUnidade) {
            var eKit = function(t) { t = String(t || '').trim(); if (t.indexOf('|') > -1 || t.indexOf(' / ') > -1) return true; if (t.indexOf(' - ') > -1 && t.indexOf('(') === -1) return true; return parseInt(t, 10) > 1; };
            var ci = product.options.findIndex(function(o) { return /cor|color|colour/i.test(o.name); });
            var un = ci < 0 ? [] : product.variants.filter(function(v) { return !eKit(v.options[ci]); });
            if (un.length && un.length < product.variants.length) {
              product.variants = un;
              product.options.forEach(function(o, i) {
                o.values = o.values.filter(function(val) { return un.some(function(v) { return v.options[i] === val; }); });
              });
              product.price = Math.min.apply(null, un.map(function(v) { return v.price; }));
              var maisBarata = un.filter(function(v) { return v.price === product.price; })[0];
              product.compare_at_price = maisBarata && maisBarata.compare_at_price || 0;
            }
          }
          self.currentProduct = product;
          self.renderModal(product);
          self.openModal();
        })
        .catch(function(e) { 
          alert('Erro ao carregar produto. Tente novamente.');
        });
    },
    
    renderModal: function(product) {
  var modalBody = document.getElementById('cyModalBody');
  if (!modalBody) return;
  
  var hasDiscount = product.compare_at_price > product.price;
  var discount = hasDiscount ? Math.round((1 - product.price/product.compare_at_price)*100) : 0;
  var fmt = function(p) { return new Intl.NumberFormat('pt-BR', {style:'currency',currency:'BRL'}).format(p/100); };
  
  var colorOpt = product.options.find(function(o) { return o.name.match(/cor|color|colour/i); });
  var sizeOpt = product.options.find(function(o) { return o.name.match(/tamanho|size|tam/i); });
  
  // ✅ IMAGENS COM LAZY LOADING - Mostra até 5 imagens
  var html = '<div class="cy-product-info"><div class="cy-product-image"><div class="cy-carousel-track">';
  /* CYGNUSS 30/10/2026: fotos no tamanho da casa pela regra unica (snippets/cyg-foto). Antes iam no original (1000+ px para 52 px). */
  var foto = function(u, t) { return window.cygFoto ? window.cygFoto(u, t) : u; };
  product.images.slice(0, 5).forEach(function(img, index) {
    img = foto(img, 'miniatura');
    // Primeira imagem carrega imediatamente, outras com lazy load
    if (index === 0) {
      html += '<div class="cy-carousel-item"><img src="' + img + '" alt="' + product.title + '" class="loaded"></div>';
    } else {
      html += '<div class="cy-carousel-item"><img data-src="' + img + '" alt="' + product.title + '" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"></div>';
    }
  });
  html += '</div></div>';
  
  html += '<div class="cy-product-details"><h4 class="cy-product-title">' + product.title + '</h4><div class="cy-product-price"><span class="cy-price-current">' + fmt(product.price) + '</span>';
  if (hasDiscount) {
    html += '<span class="cy-price-compare">' + fmt(product.compare_at_price) + '</span><span class="cy-price-discount">-' + discount + '%</span>';
  }
  if (CYG_INSTALLMENT.enabled && CYG_INSTALLMENT.count > 1) {
    var parcVal = (product.price * CYG_INSTALLMENT.factor) / CYG_INSTALLMENT.count;
    var parcSuffix = CYG_INSTALLMENT.showNoInterest ? ' sem juros' : '';
    html += '</div><div class="cy-installment">ou ' + CYG_INSTALLMENT.count + 'x de ' + fmt(parcVal) + parcSuffix + '</div></div></div>';
  } else {
    html += '</div></div></div>';
  }
  
  if (colorOpt) {
    html += '<div class="cy-variant-section"><label class="cy-variant-label">COR: <span id="selectedColor"></span></label><div class="cy-color-swatches">';
    var uniqueColors = [];
    colorOpt.values.forEach(function(c) { if (uniqueColors.indexOf(c) === -1) uniqueColors.push(c); });
    uniqueColors.forEach(function(color, i) {
      var variant = product.variants.find(function(v) { return v.options.indexOf(color) > -1; });
      var isAvailable = variant && variant.available;
      var imgSrc = product.featured_image;
      if (variant && variant.featured_image && variant.featured_image.src) imgSrc = variant.featured_image.src;
      imgSrc = foto(imgSrc, 'bolinha');
      html += '<label class="cy-color-swatch ' + (!isAvailable ? 'out-of-stock' : '') + '" title="' + color + '"><input type="radio" name="color" value="' + color + '" data-color-name="' + color + '" ' + (i===0 ? 'checked' : '') + ' ' + (!isAvailable ? 'disabled' : '') + '><img src="' + imgSrc + '" alt="' + color + '" loading="lazy"></label>';
    });
    html += '</div></div>';
  }
  
  if (sizeOpt) {
    html += '<div class="cy-variant-section"><label class="cy-variant-label">TAMANHO: <span id="selectedSize"></span></label><div class="cy-size-selector">';
    var uniqueSizes = [];
    sizeOpt.values.forEach(function(s) { if (uniqueSizes.indexOf(s) === -1) uniqueSizes.push(s); });
    uniqueSizes.forEach(function(size, i) {
      var v = product.variants.find(function(va) { return va.options.indexOf(size) > -1; });
      var av = v && v.available;
      html += '<label class="cy-size-button ' + (!av ? 'out-of-stock' : '') + '"><input type="radio" name="size" value="' + size + '" ' + (i===0 && av ? 'checked' : '') + ' ' + (!av ? 'disabled' : '') + '><span class="cy-size-button-label">' + size + '</span></label>';
    });
    html += '</div></div>';
  }
  
  html += '<div class="cy-modal-footer"><button class="cy-add-to-cart" id="cyAddToCart" type="button">Adicionar ao carrinho</button></div>';
  
  modalBody.innerHTML = html;


  // ✅ LAZY LOAD DAS IMAGENS
  this.lazyLoadImages();

  this.bindModalEvents();
  this.selectFirstAvailableVariant();
},

// ✅ NOVA FUNÇÃO PARA LAZY LOAD
lazyLoadImages: function() {
  var images = document.querySelectorAll('.cy-carousel-item img[data-src]');
  
  if ('IntersectionObserver' in window) {
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.onload = function() {
            img.classList.add('loaded');
          };
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    });

    images.forEach(function(img) {
      imageObserver.observe(img);
    });
  } else {
    // Fallback para navegadores sem IntersectionObserver
    images.forEach(function(img) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.onload = function() {
        img.classList.add('loaded');
      };
    });
  }
},
    
    bindModalEvents: function() {
      var self = this;
      
      var updateLabels = function() {
        var c = document.querySelector('input[name="color"]:checked');
        var s = document.querySelector('input[name="size"]:checked');
        var colorLabel = document.getElementById('selectedColor');
        var sizeLabel = document.getElementById('selectedSize');
        if(c && colorLabel) colorLabel.innerText = c.dataset.colorName || c.value;
        if(s && sizeLabel) sizeLabel.innerText = s.value;
        document.querySelectorAll('.cy-size-button').forEach(function(btn) {
          var inp = btn.querySelector('input[name="size"]');
          btn.classList.toggle('is-selected', !!(inp && inp.checked));
        });
        self.updateSelectedVariant();
      };

      document.querySelectorAll('input[name="color"], input[name="size"]').forEach(function(el) {
        el.addEventListener('change', updateLabels);
      });
      /* CYGNUSS 02/11/2026 (Guifa): o tamanho tocado aqui fica lembrado para os outros produtos (regra unica window.cygTam, assets/cyg.js) */
      document.querySelectorAll('input[name="size"]').forEach(function(el) {
        el.addEventListener('change', function(e) { if (e.isTrusted && window.cygTam) window.cygTam.gravar(el.value); });
      });
      
      var btn = document.getElementById('cyAddToCart');
      if(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          self.addToCart();
        });
      }
      
      updateLabels();
    },
    
    selectFirstAvailableVariant: function() {
      var self = this;
      var v = this.currentProduct.variants.find(function(x) { return x.available; });
      if (v) {
        v.options.forEach(function(opt, i) {
          var name = self.currentProduct.options[i].name.toLowerCase();
          if (name.match(/cor|color/)) {
            var inp = document.querySelector('input[name="color"][value="' + opt + '"]');
            if(inp) inp.checked = true;
          }
          if (name.match(/tamanho|size/)) {
            var inp = document.querySelector('input[name="size"][value="' + opt + '"]');
            if(inp) inp.checked = true;
          }
        });
        /* CYGNUSS 02/11/2026 (Guifa): o tamanho abre pela regra unica do tema (window.cygTam, assets/cyg.js): o ultimo escolhido
           em qualquer produto, senao G, senao o primeiro com estoque na cor marcada. O change atualiza o rotulo e a marca do botao. */
        var opcs = this.currentProduct.options.map(function(o) { return o.name; });
        var ti = opcs.findIndex(function(n) { return /tamanho|size/i.test(n); });
        var ci = opcs.findIndex(function(n) { return /cor|color/i.test(n); });
        if (window.cygTam && ti > -1) {
          var nasCor = this.currentProduct.variants.filter(function(x) { return x.available && (ci < 0 || x.options[ci] === v.options[ci]); }).map(function(x) { return x.options[ti]; });
          var tam = window.cygTam.escolher(nasCor);
          var inpT = tam && document.querySelector('input[name="size"][value="' + tam.replace(/"/g, '\\"') + '"]');
          if (inpT && !inpT.disabled) { inpT.checked = true; inpT.dispatchEvent(new Event('change')); }
        }
      }
      this.updateSelectedVariant();
    },
    
    updateSelectedVariant: function() {
      var c = document.querySelector('input[name="color"]:checked');
      var s = document.querySelector('input[name="size"]:checked');
      var btn = document.getElementById('cyAddToCart');
      if (!btn) return;
      
      var opts = [];
      if(c) opts.push(c.value);
      if(s) opts.push(s.value);
      
      var variant = this.currentProduct.variants.find(function(v) {
        return opts.every(function(o) { return v.options.indexOf(o) > -1; });
      });
      
      this.selectedVariant = variant;
      
      if (variant && variant.available) {
        btn.innerText = 'Adicionar ao carrinho';
        btn.disabled = false;
        if (variant.featured_image) {
          var firstImg = document.querySelector('.cy-carousel-item img');
          if(firstImg) firstImg.src = window.cygFoto ? window.cygFoto(variant.featured_image.src, 'miniatura') : variant.featured_image.src;
        }
      } else {
        btn.innerText = variant ? 'ESGOTADO' : 'SELECIONE AS OPÇÕES';
        btn.disabled = true;
      }
    },
    
    addToCart: function() {
      var self = this;
      
      if (!this.selectedVariant) {
        alert('Por favor, selecione as opções do produto.');
        return;
      }
      
      var btn = document.getElementById('cyAddToCart');
      if (!btn) return;
      
      var originalText = btn.innerText;
      var variantId = this.selectedVariant.id;
      
      btn.innerText = 'ADICIONANDO...';
      btn.classList.add('loading');
      btn.disabled = true;

      // Booster/Horizon: pede as sections dos cart-items no proprio add
      // p/ o morph do drawer ser instantaneo (mesmo contrato do
      // product-form.js nativo do tema).
      var body = { id: variantId, quantity: 1 };
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
        var sid = el.getAttribute('data-section-id');
        if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
      });
      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Erro ao adicionar');
        return response.json();
      })
      .then(function(item) {
        btn.innerText = '✓ ADICIONADO!';
        btn.style.background = '#28a745';

        self.closeModal();
        self.replaceCartDrawer(item);
        
        setTimeout(function() {
          btn.innerText = originalText;
          btn.style.background = '';
          btn.disabled = false;
          btn.classList.remove('loading');
        }, 2000);
      })
      .catch(function(err) {
        btn.innerText = 'ERRO - TENTE NOVAMENTE';
        btn.style.background = '#dc3545';
        setTimeout(function() {
          btn.innerText = originalText;
          btn.style.background = '';
          btn.disabled = false;
          btn.classList.remove('loading');
        }, 2500);
      });
    },
    
// =====================================================
// ATUALIZAR CART-DRAWER + CONTADOR — Booster/Horizon
// -----------------------------------------------------
// PORTE 2026-07-10: o tema Booster (base Horizon) nao usa o
// <cart-drawer> do Dawn. A cadeia nativa dele e orientada a evento:
//   1. 'cart:update' (CartAddEvent em assets/events.js) disparado em
//      document com detail { resource, sourceId, data:{ itemCount,
//      source, sections, deferDrawerOpen } };
//   2. CartItemsComponent (assets/component-cart-items.js) escuta e
//      faz morphSection(sectionId, sections[sectionId]) — ou
//      re-renderiza a section se 'sections' nao vier no payload;
//   3. CartIcon (assets/cart-icon.js) escuta e atualiza o bubble com
//      data.itemCount (valor ABSOLUTO quando source != 'product-form-component');
//   4. <cart-drawer-component> (assets/cart-drawer.js) expoe .open().
// Reproduzimos exatamente esse contrato com um CustomEvent — o
// morph e feito pelos componentes do proprio tema, zero DOM manual.
// =====================================================
replaceCartDrawer: function(addedItem) {
  var self = this;

  // /cart/add.js devolve so a line adicionada — busca o cart p/ ter
  // o item_count total (o CartIcon usa valor absoluto).
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var evt = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: addedItem && addedItem.variant_id ? String(addedItem.variant_id) : '',
          data: {
            source: 'cygnuss-quick-add',
            itemCount: cart.item_count,
            variantId: addedItem ? addedItem.variant_id : undefined,
            productId: addedItem && addedItem.product_id ? String(addedItem.product_id) : undefined,
            // sections veio no response do add (se pedimos) → morph instantaneo
            sections: (addedItem && addedItem.sections) || undefined,
            // abrimos nos mesmos via .open() abaixo, de forma deterministica
            deferDrawerOpen: true
          }
        }
      });
      document.dispatchEvent(evt);

      // Pequeno delay p/ o morph aplicar antes do drawer aparecer
      setTimeout(function() { self.openCartDrawer(); }, 120);
    })
    .catch(function(err) {
      console.error('[cy-quick-add] erro ao atualizar carrinho:', err);
      self.openCartDrawer();
    });
},

    openCartDrawer: function() {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;

      if (typeof drawer.open === 'function') {
        try { drawer.open(); return; } catch (e) {
          console.warn('[cy-quick-add] drawer.open() falhou, tentando showDialog()', e);
        }
      }
      if (typeof drawer.showDialog === 'function') {
        try { drawer.showDialog(); } catch (e) {
          console.warn('[cy-quick-add] showDialog() falhou', e);
        }
      }
    },
    
    openModal: function() {
      /* CYGNUSS 21/10/2026: o estilo do modal chega em arquivo separado (assets/cy-quick-add.css, sem bloquear a pagina).
         Se o cliente tocar antes dele chegar, espera o arquivo para abrir: sem isso a rolagem travava com o modal ainda invisivel. */
      var self = this;
      var css = document.getElementById('cyg-quick-add-css');
      if (css && !css.sheet && css.media !== 'all') {
        if (!self._cygEsperaCss) {
          self._cygEsperaCss = true;
          var abrir = function() {
            self._cygEsperaCss = false;
            if (css.sheet && self.currentProduct) self.openModal();
          };
          css.addEventListener('load', abrir, { once: true });
          css.addEventListener('error', abrir, { once: true });
        }
        return;
      }
      var overlay = document.getElementById('cyModalOverlay');
      var container = document.getElementById('cyModalContainer');
      if (overlay) overlay.classList.add('active');
      if (container) container.classList.add('active');
      // CYGNUSS 28/10/2026: a classe no html esconde os outros popups (cy-quick-add.css); antes era body:has(.cy-modal-container.active), que pesava em todo toque
      document.documentElement.classList.add('cy-modal-aberto');
      document.body.style.overflow = 'hidden';
    },
    
    closeModal: function() {
      var overlay = document.getElementById('cyModalOverlay');
      var container = document.getElementById('cyModalContainer');
      if (overlay) overlay.classList.remove('active');
      if (container) container.classList.remove('active');
      document.documentElement.classList.remove('cy-modal-aberto');
      document.body.style.overflow = '';
      this.currentProduct = null;
      this.selectedVariant = null;
    }
  };

  window.CygnussQuickAdd = CygnussQuickAdd;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { CygnussQuickAdd.init(); });
  } else {
    CygnussQuickAdd.init();
  }
})();
